import styled from "styled-components"
import {H2} from "@irati/ui/src/Headings"

const Heading = styled(H2)`
  word-break: break-all;
  word-break: break-word;
`
export default Heading
